import { Box, Typography } from '@mui/material';
import { type CourseStage } from '../model';
import CourseStageName from './CourseStageName';
import CourseStageStrip from './CourseStageStrip';

/**
 * Where a course stands, sized for a list row: the current stage named first,
 * with how many stages are done, then the stage marks unnamed. Eight names
 * beside the row's other columns would overlap, so only the current one is
 * named.
 */
export default function CourseStageSummary({
    stage,
    done,
}: {
    stage: CourseStage;
    done: readonly CourseStage[];
}) {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 0.75,
                minWidth: 0,
            }}
        >
            <Typography component="div" sx={{ fontSize: 13, fontWeight: 600 }}>
                <CourseStageName stage={stage} done={done} />
            </Typography>
            <CourseStageStrip stage={stage} done={done} labels={false} />
        </Box>
    );
}
